import React from 'react';
import { Modal } from 'antd';
import ContendingCampaignsTable from './ContendingCampaignsTable';
import './styles.scss';

type Props = {
  impressionsKey: string;
  visible: boolean;
  onClose: () => void;
};

export default function ContendingCampaignsModal({ impressionsKey, visible, onClose }: Props) {
  return (
    <Modal
      centered
      visible={visible}
      onCancel={onClose}
      footer={null}
      width="90vw"
      // Unmount on close so reopening after a new query fetches fresh data.
      destroyOnClose
      title={<span className="contending-campaigns-modal-title">Contending Campaigns</span>}
      className="contending-campaigns-modal"
    >
      {visible && impressionsKey && (
        <ContendingCampaignsTable impressionsKey={impressionsKey} scrollHeight="65vh" />
      )}
    </Modal>
  );
}
